module.exports = __webpack_public_path__ + "site/img/64.1ed95e05.jpg";